import React from "react";
import { PanelAddEmailProvider } from "../../../UI/EmailProviders/Add/PanelAddEmailProvider";

const AddEmailProvider = () => {
  return (
    <div>
      <PanelAddEmailProvider />
    </div>
  );
};

export default AddEmailProvider;
